var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlerts = function SvgAlerts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "alerts_svg2__a",
    x1: 35.08,
    x2: 184.17,
    y1: 160.97,
    y2: 38.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alerts_svg2__a",
    id: "alerts_svg2__b",
    x1: -22.16,
    x2: 126.92,
    y1: 91,
    y2: -30.98
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alerts_svg2__a",
    id: "alerts_svg2__c",
    x1: 39.49,
    x2: 188.57,
    y1: 166.35,
    y2: 44.37
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M161.78 11.14c-2.44-2.44-6.4-2.44-8.84 0s-2.44 6.4 0 8.84c16.92 16.93 26.23 39.42 26.23 63.35 0 3.45 2.8 6.25 6.25 6.25s6.25-2.8 6.25-6.25c0-27.27-10.62-52.91-29.89-72.19",
    style: {
      fill: "url(#alerts_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.83 83.33c0-23.93 9.32-46.42 26.24-63.34 2.44-2.44 2.44-6.4 0-8.84s-6.4-2.44-8.84 0C18.95 30.42 8.33 56.07 8.33 83.33c0 3.45 2.8 6.25 6.25 6.25s6.25-2.8 6.25-6.25",
    style: {
      strokeWidth: 0,
      fill: "url(#alerts_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.15 149.28a55.85 55.85 0 0 1-19.82-42.71V83.34c0-30.05-22.85-54.87-52.08-58V6.25c0-3.45-2.8-6.25-6.25-6.25s-6.25 2.8-6.25 6.25v19.09c-29.24 3.13-52.08 27.94-52.08 58v23.23c0 16.49-7.23 32.06-19.9 42.77a14.59 14.59 0 0 0-5.1 11.08c0 8.04 6.54 14.58 14.58 14.58h38.13c2.9 14.25 15.53 25 30.62 25s27.72-10.75 30.62-25h38.13c8.04 0 14.58-6.54 14.58-14.58 0-4.27-1.86-8.31-5.18-11.14M100 187.5c-8.15 0-15.1-5.22-17.68-12.5h35.35c-2.58 7.28-9.53 12.5-17.68 12.5Zm68.75-25H31.25c-1.13 0-2.08-.95-2.08-2.08 0-.83.46-1.35.75-1.6a68.3 68.3 0 0 0 24.25-52.25V83.34c0-25.27 20.56-45.83 45.83-45.83s45.83 20.56 45.83 45.83v23.23c0 20.17 8.84 39.22 24.27 52.27.28.23.73.75.73 1.58 0 1.13-.95 2.08-2.08 2.08",
    style: {
      strokeWidth: 0,
      fill: "url(#alerts_svg2__c)"
    }
  }));
};
export default SvgAlerts;